import React from "react";
import type { FC } from "react";
import styles from "./ActionBar.module.css";

const { accordionContainer, item, itemHeading, itemContent, itemIcon } = styles;

type ItemProps = {
  title: string;
  children: React.ReactNode;
};

const Item: FC<ItemProps> = ({ children, title }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <div data-expanded={isExpanded ? "true" : "false"} className={item}>
      <button
        className={itemHeading}
        onClick={() => setIsExpanded(!isExpanded)}
        data-testid={`filters-accordion-button-${title.toLocaleLowerCase()}`}
      >
        {title}
        <span
          className={itemIcon}
          data-expanded={isExpanded ? "true" : "false"}
        >
          +
        </span>
      </button>
      <div
        className={itemContent}
        data-expanded={isExpanded ? "true" : "false"}
      >
        {children}
      </div>
    </div>
  );
};

export const Accordion = ({ children }: { children: React.ReactNode }) => {
  const items = React.Children.toArray(children).filter(
    (el) => React.isValidElement(el) && el.type === Item
  );

  return <div className={accordionContainer}>{items}</div>;
};

Accordion.Item = Item;
